module.exports = ".popup .header {\n  padding: 1em;\n}\n.popup .header i.good {\n  color: #49C900;\n}\n.popup .header i.forbidden {\n  color: #e5412d;\n}\n.popup .content {\n  padding: 0 1em;\n}\n.popup #feedback .feedback-message {\n  margin: 3em 0;\n  padding: 0 1em;\n  text-align: center;\n}\n.popup #feedback button {\n  width: 100%;\n  border-top: 1px solid #727272;\n  padding: 1em 2em;\n  color: #fff;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 1em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popup/types/pictureAuth/popup-picture-auth.component.less
// module id = 472
// module chunks = 0